import mobilePopup from '../popup/mobile-popup.js';
import { initForMedia, delegateEvent } from '../utils/index.js';

let containerDOM;
/** @type {() => void} */
let removeTooltipClickListener;

/**
 * Opens popup window with tooltip content
 * @param {Event} e
 */
const openTooltipPopup = (e) => {
  const targetElement = e.target;
  const popupContent = targetElement.closest('.js-tooltip-container').querySelector('.js-tooltip-body-content').innerHTML;

  mobilePopup.show(popupContent);
};

const initMobileTooltips = () => {
  removeTooltipClickListener = delegateEvent(containerDOM, 'click', '.js-tooltip-trigger', openTooltipPopup);
};

const initDesktopTooltips = () => {
  if (removeTooltipClickListener) {
    removeTooltipClickListener();
  }
};

const initTooltips = (tooltipsContainer) => {
  if (!tooltipsContainer) {
    return;
  }

  containerDOM = tooltipsContainer;
  mobilePopup.init();

  initForMedia({
    onDesktopToTablet: initMobileTooltips,
    onTabletToDesktop: initDesktopTooltips
  });
};

export default initTooltips;
